import axios from "axios";

const Instance = axios.create({
  // baseURL: "https://dev-b2bfin.levon-global.com/api/v1", //development 
    baseURL: "https://b2bfin.levon-global.com/api/v1", //production
// baseURL: "http://localhost:5001/api/v1", //local
});

// ✅ Add Authorization header for every request
Instance.interceptors.request.use(
  (config) => {
    
   const token = JSON.parse(localStorage.getItem("userData"))?.token;
// get token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default Instance;
